import React, { Component, Fragment } from "react";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";

import { persist, store } from './store'
import { interceptor } from './services/interceptor-service'
// Device detection
import { isMobile, isTablet, withOrientationChange } from "react-device-detect";

import Signup from "./scenes/signup";
import Login from "./scenes/login";

// Routing
import {BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Home from "./scenes/home";
import ForgotPassword from "./scenes/forgot-password/index";
import ChangePassword from './scenes/forgot-password/changePassword'
import IsMobile from './components/IsMobile';
import IsLandscape from './components/IsLandscape';

class App extends Component {

  constructor(){
    super();
    interceptor.addInterceptor();
  }

  render(){
    return(
      <Fragment>
        {isMobile && !isTablet ? <IsMobile /> :
          <Provider store={store}>
            <PersistGate persistor={persist}>
              {this.props.isPortrait && <IsLandscape />}
              <Router>
                <Switch>
                  <Route exact path="/" component={Login}/>
                  <Route exact path ="/register" component={Signup}/>
                  <Route exact path="/forgot" component={ForgotPassword}/>
                  <Route exact path="/resetpassword" component={ChangePassword}/>
                  <Home />
                </Switch>
              </Router>
            </PersistGate>
          </Provider>
        }
      </Fragment>
    )
  }
}

App = withOrientationChange(App)

export { App }
